import { useCallback } from 'react';
import TagManager from 'react-gtm-module';

export const useGTM = () => {
  const pushEvent = useCallback((eventName, eventData = {}) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...eventData,
      },
    });
  }, []);

  const pushPageView = useCallback((pageName) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'page_view',
        page_name: pageName,
      },
    });
  }, []);

  const pushButtonClick = useCallback((buttonName, additionalData = {}) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'button_click',
        button_name: buttonName,
        ...additionalData,
      },
    });
  }, []);

  return {
    pushEvent,
    pushPageView,
    pushButtonClick,
  };
};
